export default __webpack_public_path__ + "static/media/misc-books3-1024w.d85cb3f7.webp";